import React from "react";

/**
 * A reusable component to display master record details in a summary card.
 * Useful for child entry pages to provide context.
 * 
 * @param {Object} props
 * @param {string} props.title - The title of the summary (e.g., "Purchase Master Details")
 * @param {Array} props.details - Array of { label, value } objects to display
 * @param {boolean} props.isLoading - Whether the parent data is being loaded
 */
const MasterDetailSummary = ({ title, details, isLoading }) => {
  if (isLoading) {
    return (
      <div className="animate-pulse rounded-2xl border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900">
        <div className="mb-4 h-6 w-1/3 rounded bg-slate-200 dark:bg-slate-700"></div>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-10 rounded bg-slate-100 dark:bg-slate-800"></div>
          ))}
        </div>
      </div>
    );
  }

  if (!details || details.length === 0) return null;

  return (
    <div className="rounded-2xl border border-primary-100 bg-primary-50/30 p-4 dark:border-primary-900/30 dark:bg-primary-900/10">
      <h2 className="mb-3 text-sm font-bold uppercase tracking-wider text-primary-700 dark:text-primary-400">
        {title}
      </h2>
      <div className="grid grid-cols-2 gap-x-6 gap-y-3 lg:grid-cols-3 xl:grid-cols-5">
        {details.map((detail, index) => (
          <div key={index} className="flex flex-col">
            <span className="text-[10px] font-semibold uppercase text-slate-500 dark:text-slate-500">
              {detail.label}
            </span>
            <span className="mt-0.5 text-sm font-medium text-slate-900 dark:text-slate-200">
              {detail.value || "-"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasterDetailSummary;
